<template>
  <a-form
    class="root"
    :model="model"
    :rules="rules"
    @validate="errors.onValidate"
    @finish="onFinish"
  >
    <a-form-item
      name="lastName"
      :help="errors.getError('lastName')"
      :validate-status="errors.getStatus('lastName')"
    >
      <a-input v-model:value="model.lastName" placeholder="Ваша фамилия" />
    </a-form-item>

    <a-form-item
      name="firstName"
      :help="errors.getError('firstName')"
      :validate-status="errors.getStatus('firstName')"
    >
      <a-input v-model:value="model.firstName" placeholder="Ваше имя" />
    </a-form-item>

    <a-form-item
      name="middleName"
      :help="errors.getError('middleName')"
      :validate-status="errors.getStatus('middleName')"
    >
      <a-input v-model:value="model.middleName" placeholder="Ваше отчество" />
    </a-form-item>

    <a-form-item
      name="email"
      :help="errors.getError('email')"
      :validate-status="errors.getStatus('email')"
    >
      <a-input v-model:value="model.email" placeholder="E-mail" />
    </a-form-item>

    <a-form-item
      name="phone"
      :help="errors.getError('phone')"
      :validate-status="errors.getStatus('phone')"
    >
      <a-input v-model:value="model.phone" placeholder="Номер телефона" />
    </a-form-item>

    <a-form-item
      v-if="isStudent"
      name="course_number"
      :help="errors.getError('course_number')"
      :validate-status="errors.getStatus('course_number')"
    >
      <a-input-number
        v-model:value="model.course_number"
        placeholder="Номер курса"
      />
    </a-form-item>

    <a-form-item
      v-if="isStudent"
      name="faculty"
      :help="errors.getError('faculty')"
      :validate-status="errors.getStatus('faculty')"
    >
      <a-input v-model:value="model.faculty" placeholder="Факультет" />
    </a-form-item>

    <a-form-item
      name="coverLetter"
      :help="errors.getError('coverLetter')"
      :validate-status="errors.getStatus('coverLetter')"
    >
      <a-textarea
        v-model:value="model.coverLetter"
        placeholder="Расскажите ту информацию о себе, которая, на ваш взгляд, будет полезна для руководителя проекта и будет способствовать приглашению Вас в команду."
        :autoSize="{ minRows: 5, maxRows: 5 }"
      />
    </a-form-item>

    <right-panel-buttons class="buttons">
      <button-primary html-type="submit" :loading="isLoading">
        Отправить
      </button-primary>
    </right-panel-buttons>
  </a-form>
</template>

<script setup>
  import { reactive, ref } from 'vue';
  import { useApi } from '@/api/use-api';
  import ButtonPrimary from '@/views/portal/components/UI/ButtonPrimary.vue';
  import RightPanelButtons from '@/views/portal/components/panels/RightPanelButtons.vue';
  import ErrorsHandler from '@/components/form/errors-handler';
  import { useRoute } from 'vue-router';

  defineProps({
    isStudent: {
      type: Boolean,
      default: false,
    },
  });

  const route = useRoute();
  const api = useApi();
  const emit = defineEmits(['close']);
  const isLoading = ref(false);

  const model = reactive({
    lastName: '',
    firstName: '',
    middleName: '',
    email: '',
    phone: '',
    coverLetter: '',
    course_number: null,
    faculty: '',
  });

  const rules = {
    lastName: [
      {
        required: true,
        min: 2,
        max: 50,
        message: 'Введите не менее 2 и не более 50 символов',
        trigger: 'blur',
      },
    ],
    firstName: [
      {
        required: true,
        min: 2,
        max: 50,
        message: 'Введите не менее 2 и не более 50 символов',
        trigger: 'blur',
      },
    ],
    middleName: [
      {
        min: 2,
        max: 50,
        message: 'Введите не менее 2 и не более 50 символов',
        trigger: 'blur',
      },
    ],
    email: [
      {
        required: true,
        type: 'email',
        message: 'Введите корректный адрес электронной почты',
        trigger: 'blur',
      },
    ],
    phone: [
      {
        min: 7,
        max: 30,
        message: 'Введите не менее 7 и не более 30 цифр',
        trigger: 'blur',
      },
    ],
    course_number: [
      {
        required: true,
        message: 'Введите номер курса',
        trigger: 'blur',
      },
    ],
    faculty: [
      {
        required: true,
        message: 'Введите название университет',
        trigger: 'blur',
      },
    ],
    coverLetter: [
      {
        min: 20,
        message: 'Введите не менее 20 символов',
      },
    ],
  };

  const errors = new ErrorsHandler({
    lastName: '',
    firstName: '',
    middleName: '',
    email: '',
    phone: '',
    course_number: '',
    faculty: '',
    coverLetter: '',
  });

  const onFinish = async () => {
    try {
      isLoading.value = true;
      await api.projectTeamRequest.create({
        projectId: route.params.id,
        lastName: model.lastName,
        firstName: model.firstName,
        middleName: model.middleName,
        email: model.email,
        phone: model.phone,
        course_number: model.course_number,
        faculty: model.faculty,
        coverLetter: model.coverLetter,
      });

      emit('close');
    } catch (error) {
      errors.handleApiErrors(error);
    } finally {
      isLoading.value = false;
    }
  };
</script>

<style scoped lang="scss">
  .root {
    max-width: 339px;
    margin-left: 16px;

    .ant-input-number {
      width: 100%;
    }
  }
</style>
